import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { ResponsableHierarchiqueDto } from "../../../dto/GenApi.iNotPaie.Dto/ResponsableHierarchiqueDto";
import { SalarieContratDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieContratDto";
import { SalarieContratHistoriqueDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieContratHistoriqueDto";
import { SalarieDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieDto";
import { ScenariosDto } from "../../../dto/GenApi.iNotPaie.Dto/ScenariosDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { EventBus } from "../../Controls/EventBus";
import EventConstants, { RoleConstants } from "../../Controls/EventConstants";
import { ParametresInstance } from "../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../../modalComponents/modalAlerte/modalAlerte";
import { regimeAideChoixKey } from "../../entreeSalarie/modalRegimeDecision/regimeDecisionEntree.tree";

interface salarieChargeInfos {
    errorMessage: string[];
    isModified: boolean;
    salarieCourant?: SalarieContratDto;
    contratsHistorique: SalarieContratHistoriqueDto[];
    proprietePrincipalesChanged: boolean
}

@Component({
    components: {
        ListeRubriquesSalarieComponent: require("../listeRubriques/listeRubriquesSalarie.vue.html"),
        ModalHoraireHebdo: require("../../modalComponents/modalHoraireHebdo/modalHoraireHebdo.vue.html"),
        ModalRegimeDecisionEntreeSalarie: require("../../entreeSalarie/modalRegimeDecision/modalRegimeDecisionEntreeSalarie.vue.html")
    }
})
export default class ContratSalarieComponent extends Vue {
    public currentId = 0;
    public dataReady = false;
    public isModified = false;
    public isModDemarrage = false;
    public errorMessage: string[] = [];
    public salarieCharges: salarieChargeInfos[] = [];
    public salarieCourant?: SalarieContratDto;
    public listeResponsablesHierarchiques: ResponsableHierarchiqueDto[] = [];
    public listeResponsablesHierarchiquesFiltres: ResponsableHierarchiqueDto[] = [];
    public listeSalarieEnCours: SalarieDto[] = [];
    public contratsHistorique: SalarieContratHistoriqueDto[] = [];
    public proprietePrincipalesChanged = false;

    //* * Les listes des combos **//
    public listeNatureContrats: ParametreDto[] = [];
    public listeTypeContrats: ParametreDto[] = [];
    public listeRemunerations: ParametreDto[] = [];
    public listeMaladieRetraitesFiltree: ParametreDto[] = [];
    private listeMaladieRetraites: ParametreDto[] = [];
    public listeTransports: ParametreDto[] = [];
    public listeGestionConges: ParametreDto[] = [];
    public listeCaisseComplementaires: ParametreDto[] = [];
    public listeMotifRecours: ParametreDto[] = [];
    public listeMotifRecoursFiltered: ParametreDto[] = [];
    public listeServices: ParametreDto[] = [];
    public listeHandicapes: ParametreDto[] = [];
    public listeDiplomesPrepares: ParametreDto[] = [];
    public listeScenarios: ScenariosDto[] = [];
    public tempsPartielCotisantTempsPleins: ParametreDto[] = [];

    public isInitialized = false;
    public canModify = false;
    public ifModeCongeActive = true;

    public readonly regimeAideChoixKey = regimeAideChoixKey;
    private regimeMemoPourAide = "";
    public isManualChoice = false;
    public modalRegimeDecisionVisible = false;

    public reloadData(id: number): void {
        if (this.currentId > 0) {
            this.salarieCharges[this.currentId] = {
                contratsHistorique: this.contratsHistorique,
                errorMessage: this.errorMessage,
                isModified: this.isModified,
                salarieCourant: this.salarieCourant,
                proprietePrincipalesChanged: this.proprietePrincipalesChanged
            };
        }
        this.currentId = id;
        this.fetchData();
    }

    public refreshContrat(): void {
        // Resynchronisation demandée par l'onglet Qualifications après un enregistrement :
        // le DTO mémorisé est périmé par construction, on relit systématiquement le serveur.
        this.fetchData(true);
    }

    public modifyTypeDeContrat(): void {
        if (this.salarieCourant != undefined) {
            this.salarieCourant.ExonerationCsg = this.salarieCourant.CodeTypeContrat == "APP";
        }
        this.modifyInfoCsg();
        this.modifyPropertiesPrincipales();
    }

    public modifyPropertiesPrincipales(): void {
        this.proprietePrincipalesChanged = true && this.salarieCourant != undefined && this.salarieCourant.ContratActif;
        this.modifyForRubriques();
    }

    public modifyForRubriques(): void {
        this.modify();
        this.$children.forEach(c => {
            const child: any = c;
            if (child.refreshRubriquesVisibleContrat != undefined) {
                child.refreshRubriquesVisibleContrat();
            }
        });
    }

    public modifyCaisseComplementaire(codeCaisseComplementaire?: string): void {
        this.modify();
        this.$children.forEach(c => {
            const child: any = c;
            if (child.refreshRubriquesVisibleContrat != undefined) {
                let caisse: ParametreDto | undefined;
                if (codeCaisseComplementaire != undefined) {
                    const caissesComplementaires = this.listeCaisseComplementaires.filter(c => c.Code == codeCaisseComplementaire);
                    if (caissesComplementaires != undefined && caissesComplementaires[0] != undefined) {
                        caisse = caissesComplementaires[0];
                    }
                }
                child.refreshRubriquesVisibleContrat(caisse);
            }
        });
    }

    public init(): void {
        if (this.isInitialized || ParametresInstance.utilisateurCourant == undefined || ParametresInstance.societeCourante == undefined) {
            return;
        }

        this.canModify = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]) && this.salarieCourant != undefined && this.salarieCourant.IsCurrent;
        this.ifModeCongeActive = ParametresInstance.societeCourante.IsModeCongeActive;

        this.initConstantes();

        this.isInitialized = true;
    }

    public mounted(): void {
        this.isInitialized = false;

        // On ne sait pas dans quel ordre ça peut arriver (1er appel ou refresh de la page...)
        EventBus.$on(EventConstants.UTILISATEUR_CHANGED, () => {
            this.init();
        });

        EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
            this.isModDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);
        });
        this.isModDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);

        this.init();
    }

    public resetData(id: number): void {
        if (this.salarieCharges[id] != undefined) {
            this.salarieCharges[id].isModified = false;
        }
        if (this.currentId == id) {
            this.fetchData();
        }
    }

    public initConstantes(): void {
        ServicesFactoryInstance.ParametresService.getNatureContrats(data => {
            this.listeNatureContrats = data;
        });
        ServicesFactoryInstance.ParametresService.getTypeContrats(data => {
            this.listeTypeContrats = data;
        });
        ServicesFactoryInstance.ParametresService.getMaladieRetraites(true, data => {
            this.listeMaladieRetraites = data;
            if (ParametresInstance.estSocieteAlsaceMoselle() || ParametresInstance.estSocieteDomTom()) {
                this.listeMaladieRetraites = this.listeMaladieRetraites.filter(regime => regime.Code != "CRPUR");
            }
            this.listeMaladieRetraitesFiltree = this.listeMaladieRetraites;
            this.setListeMaladieRetraitesFiltrees();
        });
        ServicesFactoryInstance.ParametresService.getRemunerations(data => {
            this.listeRemunerations = data;
        });
        ServicesFactoryInstance.ParametresService.getTransports(data => {
            this.listeTransports = data;
        });
        ServicesFactoryInstance.ParametresService.getGestionConges(data => {
            this.listeGestionConges = data;
        });
        ServicesFactoryInstance.ParametresService.getCaisseComplementaires(data => {
            this.listeCaisseComplementaires = data;
        });
        ServicesFactoryInstance.ParametresService.getMotifRecours(data => {
            this.listeMotifRecours = data;
        });
        ServicesFactoryInstance.ParametresService.getServices(data => {
            this.listeServices = data;
        });
        ServicesFactoryInstance.ParametresService.getHandicapes(data => {
            this.listeHandicapes = data;
        });
        ServicesFactoryInstance.ParametresService.getDiplomesPrepares(data => {
            this.listeDiplomesPrepares = data;
        });
        ServicesFactoryInstance.ScenariosService.getScenariosByNat("S", (data) => {
            this.listeScenarios = data.filter(s => s.CodeTypeScenario == "ORGAN");
        });

        ServicesFactoryInstance.ParametresService.getTempsPartielCotisantTempsPleins(data => {
            this.tempsPartielCotisantTempsPleins = data;
        });
    }

    public fetchData(forceReload = false): void {
        if (this.currentId < 1) {
            return;
        }

        this.dataReady = false;
        if (forceReload || this.salarieCharges[this.currentId] == null || !this.salarieCharges[this.currentId].isModified) {
            // Données relues depuis le serveur : aucune modification en cours sur ce salarié.
            // Sans ce reset, le flag fuit d'un salarié à l'autre (le composant est unique) et
            // le bloc Valider/Annuler s'affiche sans qu'aucun champ n'ait été touché.
            // setData() le repositionne si le salarié n'a pas encore de contrat.
            this.isModified = false;

            if (isNaN(Number(this.$route.query.idContrat))) {
                ServicesFactoryInstance.SalarieService.getSalarieQualification(this.currentId, this.setData, () => this.dataReady = true);
            } else {
                ServicesFactoryInstance.SalarieService.getSalarieQualificationForContrat(this.currentId, Number(this.$route.query.idContrat), this.setData, () => this.dataReady = true);
            }
        } else {
            this.isModified = this.salarieCharges[this.currentId].isModified;
            this.errorMessage = this.salarieCharges[this.currentId].errorMessage;
            this.salarieCourant = this.salarieCharges[this.currentId].salarieCourant;
            this.contratsHistorique = this.salarieCharges[this.currentId].contratsHistorique;
            this.proprietePrincipalesChanged = this.salarieCharges[this.currentId].proprietePrincipalesChanged;
            this.setData(this.salarieCourant);
        }
    }

    public setData(data?: SalarieContratDto): void {
        if (data == undefined || data.IdSalarie != this.currentId) {
            return;
        }

        this.salarieCourant = data;
        this.setListeMaladieRetraitesFiltrees();
        this.regimeMemoPourAide = this.salarieCourant?.CodeMaladieRetraite ?? "";
        this.isManualChoice = false;

        ServicesFactoryInstance.SalarieService.getListeResponsablesHierarchiques(data => {
            this.listeResponsablesHierarchiques = data;
            this.listeResponsablesHierarchiquesFiltres = this.listeResponsablesHierarchiques.filter(d => d.IdSalarie != this.currentId).sort((a, b) => `${a.Nom} ${a.Prenom}` > `${b.Nom} ${b.Prenom}` ? 1 : -1);
        }, () => {
            this.listeResponsablesHierarchiques = [];
            this.listeResponsablesHierarchiquesFiltres = [];
        });

        ServicesFactoryInstance.SalarieService.getSalariesEnCours(data => {
            this.listeSalarieEnCours = data;
        }, () => {
            this.listeSalarieEnCours = [];
        });

        if (this.salarieCourant && this.salarieCourant.IdContrat == 0) {
            this.isModified = true;
            this.salarieCourant.RubriqueContrats = [];
        }
        this.contratsHistorique = [];

        ServicesFactoryInstance.SalarieService.getSalarieContratHistorique(this.currentId, data => {
            this.contratsHistorique = data;
            this.contratsHistorique.sort((a, b) => a.DateDebut != undefined && b.DateDebut != undefined && a.DateDebut > b.DateDebut ? -1 : 1);
        });

        this.setlisteMotifRecoursFiltered();

        this.proprietePrincipalesChanged = false;

        this.dataReady = true;
        this.$forceUpdate();

        this.canModify = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]) && this.salarieCourant != undefined && this.salarieCourant.IsCurrent;
    }

    public deleteContrat(idContrat: any): void {
        const modalAlerteAvecCallback: ModalAlerteOptions = new ModalAlerteOptions(
            {
                message: "Souhaitez-vous vraiment supprimer ce contrat ?",
                callBackYes: () => {
                    this.dataReady = false;
                    NotificationServiceInstance.SendSuccess("Suppression du contrat");
                    ServicesFactoryInstance.SalarieService.deleteContrat(idContrat, () => {
                        ServicesFactoryInstance.SalarieService.getSalarieContratHistorique(this.currentId, data => {
                            this.contratsHistorique = data;
                            this.contratsHistorique.sort((a, b) => a.DateDebut != undefined && b.DateDebut != undefined && a.DateDebut > b.DateDebut ? -1 : 1);
                            this.dataReady = true;
                        });

                        NotificationServiceInstance.SendSuccess("La suppression du contrat s'est correctement déroulée !");
                    }, () => {
                        this.dataReady = true;
                    });
                },
                canClose: true,
                showDialog: true,
                title: "Suppression du contrat"
            });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalAlerteAvecCallback);
    }

    public enregistrer(): boolean {
        if (this.salarieCourant == undefined) {
            return false;
        }

        const regimeSelectionne = this.listeMaladieRetraites.find(r => r.Code === this.salarieCourant!.CodeMaladieRetraite);
        if (regimeSelectionne?.EstArchive) {
            NotificationServiceInstance.SendFailed("Le régime sélectionné est obsolète et ne peut plus être utilisé. Veuillez sélectionner un autre régime maladie/retraite.");
            return false;
        }

        if (this.proprietePrincipalesChanged) {
            const modalAlerteAvecCallback: ModalAlerteOptions = new ModalAlerteOptions(
                {
                    message: "Vous avez effectué une modification du contrat impliquant un changement dans la DSN. Souhaitez-vous vraiment valider votre modification ?",
                    callBackYes: () => {
                        this.proprietePrincipalesChanged = false;
                        this.enregistrer();
                    },
                    canClose: true,
                    showDialog: true,
                    title: "Modification du contrat"
                });
            EventBus.$emit(EventConstants.MODAL_ALERT, modalAlerteAvecCallback);

            return false;
        }

        this.$children.forEach(c => {
            const child: any = c;
            if (child.updateSalarie != undefined) {
                child.updateSalarie();
            }
        });

        if (this.salarieCourant.IdSociete == undefined && ParametresInstance.societeCourante != undefined) {
            this.salarieCourant.IdSociete = ParametresInstance.societeCourante.Id;
        }

        this.dataReady = false;
        ServicesFactoryInstance.SalarieService.updateSalarieContrat(this.salarieCourant, data => {
            this.setData(data);
            if (this.salarieCharges[this.currentId] != undefined) {
                // Le DTO mémorisé est périmé après un enregistrement : la prochaine
                // lecture doit repartir du serveur.
                this.salarieCharges[this.currentId].isModified = false;
            }
            this.$emit("isModified", false);
            this.$emit("contratUpdated");
            this.isModified = false;
            NotificationServiceInstance.SendSuccess("L'enregistrement du salarié s'est correctement déroulé !");
        }, () => {
            this.dataReady = true;
        });

        return false;
    }

    public modifyResponsableHierarchique(): void {
        this.modify();
    }

    public modifyAssistantDeGestion(): void {
        this.modify();
    }

    public modifyTreiziemeMois(): void {
        if (this.salarieCourant != undefined && !this.salarieCourant.TreiziemeMois) {
            this.salarieCourant.EstTreiziemeMoisMensualise = false;
        }
        this.modifyForRubriques();
    }

    public annuler(): void {
        if (this.salarieCharges[this.currentId] != undefined) {
            this.salarieCharges[this.currentId].isModified = false;
        }
        this.fetchData();
        this.isModified = false;
        this.$emit("isModified", false);
    }

    public modify(): void {
        this.$emit("isModified", true);
        this.isModified = false;
        this.isModified = true;
    }

    public viewDetails(contrat: SalarieContratHistoriqueDto): void {
        if (this.salarieCourant == undefined || contrat.IdContrat == undefined) {
            return;
        }

        const idContrat = contrat.IdContrat.toString();

        this.isModified = false;
        this.$emit("contratHistoriqueUpdated");
        EventBus.NavigateTo({
            path: "/ficheSalarie/" + contrat.IdSalarie,
            query: { titre: "Historique contrat N° " + contrat.NumeroSalarie, idContrat: idContrat }
        });
    }

    public modifyInfoCsg(): void {
        this.$children.forEach(c => {
            const child: any = c;
            if (child.setInfoCsg != undefined) {
                child.setInfoCsg(this.salarieCourant?.DateDebut);
            }
        });
    }

    /**
     * Intercepte le clic sur le select régime : si la valeur est vide, ouvre le questionnaire
     * plutôt que de laisser la liste native s'ouvrir.
     */
    public onRegimeMouseDown(ev: MouseEvent): void {
        if (!this.canModify || this.isManualChoice) return;
        if (!this.salarieCourant?.CodeMaladieRetraite) {
            ev.preventDefault();
            this.modalRegimeDecisionVisible = true;
        }
    }

    /**
     * Changement de valeur du select régime : si l'aide est sélectionnée, ouvre le
     * questionnaire et restaure la valeur précédente, sinon, propage normalement.
     */
    public onRegimeChanged(): void {
        if (this.salarieCourant?.CodeMaladieRetraite === regimeAideChoixKey) {
            const restore = this.regimeMemoPourAide;
            this.modalRegimeDecisionVisible = true;
            this.salarieCourant!.CodeMaladieRetraite = restore;
        } else {
            this.regimeMemoPourAide = this.salarieCourant?.CodeMaladieRetraite ?? "";
            this.modifyPropertiesPrincipales();
        }

        // Permet d'empêcher l'utilisateur de re sélectionner un régime obsolète
        this.setListeMaladieRetraitesFiltrees();
    }

    /**
     * Applique le code régime proposé par le questionnaire.
     */
    public onRegimeDecisionApply(code: string): void {
        if (this.listeMaladieRetraitesFiltree.find(elt => elt.Code === code)) {
            this.salarieCourant!.CodeMaladieRetraite = code;
            this.regimeMemoPourAide = code;
            this.modifyPropertiesPrincipales();
        } else {
            this.isManualChoice = true;
            NotificationServiceInstance.SendFailed("Nous n'avons pas trouvé de code correspondant au régime proposé, veuillez saisir manuellement votre régime ou réessayer.");
        }
    }

    public isCsgApprentiActive() {
        if (this.salarieCourant != undefined) {
            return !this.canModify || this.salarieCourant.CodeTypeContrat != 'APP' || this.salarieCourant.ExonerationCsg == false;
        }
        else {
            return false;
        }
    }

    private setListeMaladieRetraitesFiltrees(): void {
        this.listeMaladieRetraitesFiltree = this.listeMaladieRetraites.filter(
            r => !r.EstArchive || r.Code === this.salarieCourant?.CodeMaladieRetraite
        );
    }

    /**
     * Récupération des motifs de recours non archivés, et archivés si enregistré ainsi
     */
    private setlisteMotifRecoursFiltered(): void {
        if (this.salarieCourant && this.listeMotifRecours) {
            this.listeMotifRecoursFiltered = this.listeMotifRecours.filter(m => !m.EstArchive || m.Code === this.salarieCourant!.CodeMotifRecours);
        } else {
            this.listeMotifRecoursFiltered = this.listeMotifRecours;
        }
    }

    /**
     * Retourne le libelle du motif de recours courant
     * @returns
     */
    private getTitleMotifRecours(): string {
        if (!this.salarieCourant?.CodeMotifRecours)
            return "";

        return this.salarieCourant.CodeMotifRecours + '/' + this.listeMotifRecoursFiltered.find(x => x.Code === this.salarieCourant?.CodeMotifRecours)?.Libelle || '';
    }
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/contratSalarie/contratSalarie.ts